import { render, staticRenderFns } from "./PendingReasonsTable.vue?vue&type=template&id=5b46e53f&scoped=true&"
import script from "./PendingReasonsTable.vue?vue&type=script&lang=js&"
export * from "./PendingReasonsTable.vue?vue&type=script&lang=js&"
import style0 from "./PendingReasonsTable.vue?vue&type=style&index=0&id=5b46e53f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46e53f",
  null
  
)

export default component.exports